module.exports = "<p>{{'page-not-found.mensaje' | translate}}</p>\r\n"